module.exports = __webpack_public_path__ + "images/FUSA_icons/097-clipboard.a4652d55ec9b3dded6ea48f33f68292e.svg";